import ApiConstant from "./ApiContstant";
import DataService from "./DataService";

export interface ResourceSpaceTypeListRequest {
  LocationId?: number;
}

export interface ResourceSpaceTypeListResponse {
  ResSpaceTypes: ResourceSpaceType[];
}

export interface ResourceSpaceType {
  id: number;
  name: string;
  icon: string | null;
}

class ResourceSpaceTypeListService {
  async getResourceSpaceTypeList(
    payload?: ResourceSpaceTypeListRequest | null
  ): Promise<ResourceSpaceType[]> {
    const response = await DataService.postData(
      localStorage.getItem("tenantUrl") + ApiConstant.GetResourceSpaceTypeList,
      payload ?? null
    );
    
    return response?.data?.d?.ResSpaceTypes ?? [];
  }
}

export default new ResourceSpaceTypeListService();
